"use strict";

/**
 * dataCloudCarousel.js
 * Client-side handler for Data Cloud Product Carousels.
 * - Finds all .dc-swiper instances on the page
 * - Fetches personalized SKUs from Data Cloud Interactions SDK per instance
 * - POSTs SKUs to DataCloudCarousel-GetTiles to get rendered tile HTML
 * - Injects tiles into the swiper and initializes each independently
 */

var dcSwiperEls = document.querySelectorAll(".dc-swiper");

if (dcSwiperEls.length > 0 && typeof DataCloudInteractions !== "undefined") {
    var siInterval = setInterval(function () {
        if (
            window.DataCloudInteractions &&
            typeof window.DataCloudInteractions.init === "function"
        ) {
            clearInterval(siInterval);

            DataCloudInteractions.init({
                consents: [],
                personalization: { dataspace: "default" }
            }).then(function () {
                dcSwiperEls.forEach(function (swiperEl) {
                    initDCSwiper(swiperEl);
                });
            }).catch(function (err) {
                console.error("DataCloudInteractions init error:", err);
                dcSwiperEls.forEach(function (swiperEl) {
                    hideSkeleton(swiperEl);
                });
            });
        }
    }, 100);
}

/**
 * Initializes a single Data Cloud carousel instance.
 * @param {HTMLElement} swiperEl - the .dc-swiper wrapper element
 */
function initDCSwiper(swiperEl) {
    var personalizationPoint = swiperEl.getAttribute("data-personalization-point");

    if (!personalizationPoint) {
        hideSkeleton(swiperEl);
        return;
    }

    DataCloudInteractions.Personalization.fetch([personalizationPoint])
        .then(function (response) {
            var personalizations = response && response.personalizations;

            if (!personalizations || personalizations.length === 0) {
                hideSkeleton(swiperEl);
                return;
            }

            var firstPersonalization = personalizations[0];

            // Resolve headline: data attribute (PD) takes priority, fall back to Data Cloud
            var headline = swiperEl.getAttribute("data-headline") ||
                (firstPersonalization.attributes && firstPersonalization.attributes.header) ||
                null;

            var intro = swiperEl.getAttribute("data-intro") || null;

            // Extract SKUs
            var skus = (firstPersonalization.data || [])
                .map(function (item) { return item.ssot__Id__c; })
                .filter(Boolean);

            if (skus.length === 0) {
                hideSkeleton(swiperEl);
                return;
            }

            // Fetch rendered tile HTML from controller
            var tilesURL = $(".dc-swiper").data("tiles-url") ||
                window.Urls && window.Urls.dataCloudGetTiles;

            // Build URL with SKUs
            var getTilesURL = swiperEl.getAttribute("data-tiles-url") + "?skus=" + encodeURIComponent(skus.join(","));

            fetch(getTilesURL)
                .then(function (res) { return res.text(); })
                .then(function (html) {
                    buildCarousel(swiperEl, headline, intro, html);
                })
                .catch(function (err) {
                    console.error("DataCloudCarousel-GetTiles error:", err);
                    hideSkeleton(swiperEl);
                });
        })
        .catch(function (err) {
            console.error("DataCloudInteractions fetch error:", err);
            hideSkeleton(swiperEl);
        });
}

/**
 * Builds and injects the carousel HTML then initializes Swiper.
 * @param {HTMLElement} swiperEl
 * @param {string|null} headline
 * @param {string|null} intro
 * @param {string} tilesHTML
 */
function buildCarousel(swiperEl, headline, intro, tilesHTML) {
    var innerHTML = "";

    if (headline) {
        innerHTML += '<div class="swiperlayout-text_container">';
        innerHTML += '<h3 class="swiperlayout-headline">' + headline + "</h3>";
        if (intro) {
            innerHTML += '<span class="swiperlayout-copy">' + intro + "</span>";
        }
        innerHTML += "</div>";
    }

    innerHTML += '<div class="swiper-track">';
    innerHTML += '<div class="swiper-wrapper">';
    innerHTML += tilesHTML;
    innerHTML += "</div>";
    innerHTML += '<button class="swiper-btn-control swiper-button-prev" aria-label="Previous Slide"></button>';
    innerHTML += '<button class="swiper-btn-control swiper-button-next" aria-label="Next Slide"></button>';
    innerHTML += "</div>";

    swiperEl.innerHTML = innerHTML;

    // Initialize Swiper manually using same config as buildFourTileSwiper
    var sliderID = "#" + swiperEl.id + " .swiper-track";
    // eslint-disable-next-line no-new, no-undef
    new Swiper(sliderID, {
        slidesPerView: 1,
        spaceBetween: 10,
        freeMode: true,
        watchSlidesProgress: true,
        a11y: {
            scrollOnFocus: true
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
        },
        breakpoints: {
            768: {
                slidesPerView: 2,
                spaceBetween: 24
            },
            991: {
                slidesPerView: 4,
                spaceBetween: 24
            }
        },
        on: {
            afterInit: function (theSwiper) {
                if (theSwiper.slides.length === 0) {
                    swiperEl.style.display = "none";
                }
            }
        }
    });
}

/**
 * Hides the skeleton loader if personalization is unavailable.
 * @param {HTMLElement} swiperEl
 */
function hideSkeleton(swiperEl) {
    swiperEl.style.display = "none";
}
